var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToolsFormTransverseTraction',{attrs:{"prop-bearing-width":_vm.bearingWidth,"prop-bearing-length":_vm.bearingLength,"prop-bearing-thickness":_vm.bearingThickness,"prop-power":_vm.power,"disable-inputs":_vm.disableInputs}})
}
var staticRenderFns = []

export { render, staticRenderFns }